import React, { createContext, useContext, useState } from "react";
import Toast from "../Component/Toast";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "error",
  });

  const showToast = (message, type = "error") => {
    setToast({ show: true, message, type });

    setTimeout(() => {
      setToast({ show: false, message: "", type });
    }, 3000);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toast.show && (
        <Toast message={toast.message} type={toast.type} />
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
